const initialState = {
  checked: false,
  isLocked: false,
  isNew: false,
  isValid: null,
  token: null,
};

export const licenseValidityReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case "SET_IS_LICENSE_CHECKED":
      return {
        ...state,
        checked: true,
        // isValid: payload.isValid,
      };

    case "SET_TOKEN":
      return {
        ...state,
        token: payload.token,
      };

    case "LOCK_LICENSE":
      return {
        ...state,
        isLocked: payload,
      };

    default:
      return state;
  }
};
